export default __webpack_public_path__ + "static/media/Prototype-documentation.f534505a.md";